<template>
  <div id="app">
    <div class="top-tabs-corporate" data-widget-host="morrisons-tabs" data-prop-site></div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted() {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute(
      'src',
      'https://images.morrisons.com/unified-tabs/bundle.js'
    )
    document.head.appendChild(recaptchaScript)
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>
<style lang="postcss">
#app {
  @apply overflow-x-hidden;
}
.top-tabs-corporate {
  @apply relative z-101;
}
</style>
